import { LI, UL } from "../../../../AbstractElements";
import { SidebarTypeProp } from "../../../../Type/CustomizerType";
import CommonUL from "../../Common/CommonUL";

const Horizontal = ({ handleSidebarType, layout }: SidebarTypeProp) => {
  return (
    <LI data-attr="compact-sidebar" className={`border-0 ${layout === "" ? "active" : ""}`} onClick={() => handleSidebarType("")}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body">
        <UL className="simple-list d-flex flex-row">
          <LI className="bg-dark sidebar compact"></LI>
          <LI className="bg-light body"></LI>
        </UL>
      </div>
    </LI>
  );
};

export default Horizontal;
